import Vue from 'vue';
import Router from 'vue-router';
import Home from '../views/Home.vue';
import Wizard from '../components/Wizard.vue';
import Details from '../views/Details.vue';
import Result from '../views/Result.vue';
import Save from '../views/Save.vue';
import MissingPage from '../views/404.vue';

Vue.use(Router);
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/wizard/:id',
      name: 'Wizard',
      component: Wizard,
    },
    {
      path: '/details/:id',
      name: 'Details',
      component: Details,
    },
    {
      path: '/result',
      name: 'Result',
      component: Result,
    },
    {
      path: '/save',
      name: 'Save',
      component: Save,
    },
    {
      path: '/404',
      name: '404',
      component: MissingPage,
    },
    {
      path: '/*',
      name: 'MissingPage',
      component: MissingPage,
    },
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});
